import { NotificationAudience } from '@pushly/models/lib/structs/notifications/notification-audience'
import { GetSegmentResponse } from '@pushly/models/lib/structs/segmentation'
import { AudienceBadgeAudience, AudienceBadgeSegment } from './audience-badge'

/**
 * Maps a snake_case GetSegmentResponse to the camelCase AudienceBadgeSegment
 * expected by AudienceBadge.
 */
function mapSegmentResponse(seg: GetSegmentResponse): AudienceBadgeSegment {
    return {
        id: seg.id,
        name: seg.name,
        type: seg.segment_type,
        isDefault: seg.is_default,
    }
}

/**
 * Maps a snake_case NotificationAudience (from GetNotificationScheduleResponse)
 * to the camelCase AudienceBadgeAudience expected by AudienceBadge.
 */
export function mapNotificationAudienceToBadge(audience: NotificationAudience): AudienceBadgeAudience {
    return {
        segments: audience.segments?.map(mapSegmentResponse),
        excludedSegments: audience.excluded_segments?.map(mapSegmentResponse),
        subscriberIds: audience.subscriber_ids,
        externalSubscriberIds: audience.external_subscriber_ids,
    }
}
